const isCoveoParameter = (key: string): boolean =>
  key === 'q' || key.startsWith('f-') || key === 'sortCriteria' || key === 'firstResult';

export const buildBlogSearchUrl = (
  targetHref: string,
  searchTerm: string,
  origin: string
): string => {
  const url = new URL(targetHref, origin);
  const fragmentParams = new URLSearchParams();

  const addCoveoParameters = (params: URLSearchParams) => {
    params.forEach((value, key) => {
      if (isCoveoParameter(key) && key !== 'q') {
        fragmentParams.set(key, value);
      }
    });
  };

  addCoveoParameters(new URLSearchParams(url.hash.slice(1)));
  addCoveoParameters(url.searchParams);
  const coveoQueryKeys = [...url.searchParams.keys()].filter(
    (key) => isCoveoParameter(key) && key !== 'q'
  );
  coveoQueryKeys.forEach((key) => url.searchParams.delete(key));

  if (searchTerm) {
    url.searchParams.set('q', searchTerm);
  } else {
    url.searchParams.delete('q');
  }

  fragmentParams.delete('firstResult');
  if (!fragmentParams.has('sortCriteria')) {
    fragmentParams.set('sortCriteria', '@cwblogdate descending');
  }

  url.hash = fragmentParams.toString().replace(/\+/g, '%20');
  return `${url.pathname}${url.search}${url.hash}`;
};
